import { useCallback } from "react";

import { emit } from "@zapier/events-toolkit-browser";

import { EmitEventInput } from "@zapier/reporting/src/types";
import {
  DEFAULT_SYSTEM_NAME_FOR_EVENT_TRACKING,
  USER_INTERACTION_EVENT,
} from "../constants";
import { useAccountAndUser } from "./useAccountAndUser";

export function useEmitEvent() {
  const { userId, accountId } = useAccountAndUser();

  const emitEvent = useCallback(
    ({ eventName = USER_INTERACTION_EVENT, meta }: EmitEventInput) => {
      if (userId && accountId) {
        emit(
          {
            // Events auto populated:
            // https://engineering.zapier.com/guides/event-streaming/creating-and-emitting-events/emitting-frontend-events/#autopopulated-fields
            account_id: accountId,
            release_id: process.env.NEXT_PUBLIC_COMMIT_SHA,
            system_name: DEFAULT_SYSTEM_NAME_FOR_EVENT_TRACKING,
            timestamp_ms: Date.now(),
            ...meta,
          },
          eventName
        );
      }
    },
    [userId, accountId]
  );

  return {
    emitEvent,
  };
}
